/*
 * il-form-validation.js
 * בדיקת תקינות של שדות ישראליים בטופס יצירת קשר: תעודת זהות, טלפון נייד, מייל.
 *
 * מופעל רק על טופס שמכיל <span class="js-il-validate">, כלומר רק כשההגדרה
 * "Israeli field validation" דלוקה בסקשן contact-form. כך העמודים האחרים
 * לא משתנים.
 *
 * הכללים נקבעו על ידי יובל, 23.08.2026:
 *   תעודת זהות  = בדיוק 9 ספרות + ספרת ביקורת.
 *   טלפון       = נייד ישראלי בלבד, 05 ועוד 8 ספרות.
 *   מייל        = מבנה כתובת תקין.
 *
 * מקור האמת לאלגוריתם הת.ז זהה לזה שבהרחבת הקופה
 * (checkout-fields-app/extensions/*\/src/validateIsraeliId.js).
 * שינוי בכלל אחד מחייב שינוי בשני המקומות.
 */
(function () {
  'use strict';

  var MSG = {
    id: 'מספר תעודת זהות אינו תקין. יש להזין 9 ספרות בדיוק, כפי שמופיע בתעודה.',
    phone: 'מספר הטלפון אינו תקין. יש להזין מספר נייד ישראלי, למשל 0501234567.',
    email: 'כתובת המייל אינה תקינה. יש להזין כתובת מלאה, למשל name@example.com.',
  };

  var STYLE_ID = 'il-form-validation-style';

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent =
      '.il-field-error{display:block;margin:.4rem 0 1rem;font-size:1.3rem;line-height:1.4;color:#c62828}' +
      '.il-field-error[hidden]{display:none}' +
      '.field__input.il-invalid{border-color:#c62828}';
    document.head.appendChild(s);
  }

  // ---- כללי התקינות ------------------------------------------------------

  function digitsOnly(v) {
    return String(v == null ? '' : v).replace(/\D/g, '');
  }

  // ספרת ביקורת רשמית של תעודת זהות ישראלית (Luhn). לא מאמת שהמספר שייך לאדם
  // אמיתי, רק שהמבנה תקין.
  function isValidIsraeliId(value) {
    var d = digitsOnly(value);
    if (d.length !== 9) return false;
    var sum = 0;
    for (var i = 0; i < 9; i++) {
      var step = Number(d[i]) * ((i % 2) + 1);
      if (step > 9) step -= 9;
      sum += step;
    }
    return sum % 10 === 0;
  }

  // נייד ישראלי בלבד. מקבל גם קידומת בינלאומית ומנרמל אותה ל-0.
  function isValidIsraeliMobile(value) {
    var d = digitsOnly(value);
    if (d.indexOf('972') === 0) d = '0' + d.slice(3);
    return /^05\d{8}$/.test(d);
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[A-Za-z]{2,}$/.test(String(value || '').trim());
  }

  // ---- זיהוי סוג השדה ----------------------------------------------------

  function labelTextOf(input) {
    var byFor = input.id ? document.querySelector('label[for="' + input.id + '"]') : null;
    var text = (byFor && byFor.textContent) || (input.closest('label') || {}).textContent || '';
    return (text + ' ' + (input.placeholder || '') + ' ' + (input.name || '')).replace(/\s+/g, ' ');
  }

  function kindOf(input) {
    if (input.type === 'email') return 'email';
    if (input.type === 'tel') return 'phone';
    if (input.type === 'text' && /תעודת זהות|ת\.?\s?ז\b/.test(labelTextOf(input))) return 'id';
    return null;
  }

  var CHECK = { id: isValidIsraeliId, phone: isValidIsraeliMobile, email: isValidEmail };

  // ---- הצגת השגיאה -------------------------------------------------------

  // 🔴 החיפוש והשתילה חייבים לשבת באותו מקום. עד 06.09.2026 החיפוש היה
  //    ב-`input.parentElement`, שהוא ה-`.field`, והשתילה ב-`.field`.parentElement.
  //    ⟹ החיפוש לעולם לא מצא, ותיבה חדשה נוצרה בכל אימות.
  //    נמדד: חמישה אימותים הותירו חמש הודעות זהות זו מתחת לזו, בצור קשר
  //    ובביטול עסקה כאחד. אין שגיאה, וזה נראה כמו תקלת רינדור.
  //    ההפניה נשמרת עכשיו על השדה עצמו, ולכן הצמד אינו יכול להיפרד שוב.
  function errorBox(input) {
    if (input.ilErrorBox && input.ilErrorBox.isConnected) return input.ilErrorBox;
    var box = document.createElement('span');
    box.className = 'il-field-error';
    box.setAttribute('role', 'alert');
    box.hidden = true;
    var anchor = input.closest('.field') || input;
    if (anchor.parentElement) anchor.parentElement.insertBefore(box, anchor.nextSibling);
    else input.insertAdjacentElement('afterend', box);
    input.ilErrorBox = box;
    return box;
  }

  function setError(input, message) {
    var box = errorBox(input);
    if (message) {
      box.textContent = message;
      box.hidden = false;
      input.setAttribute('aria-invalid', 'true');
      input.classList.add('il-invalid');
    } else {
      box.textContent = '';
      box.hidden = true;
      input.removeAttribute('aria-invalid');
      input.classList.remove('il-invalid');
    }
    input.setCustomValidity(message || '');
  }

  // שדה ריק נשאר באחריות required של הדפדפן, כדי לא לשכפל הודעות.
  function validate(input, kind) {
    var raw = input.value == null ? '' : input.value.trim();
    if (raw === '') { setError(input, ''); return true; }
    var ok = CHECK[kind](raw);
    setError(input, ok ? '' : MSG[kind]);
    return ok;
  }

  // ---- חיווט -------------------------------------------------------------

  function attach(form) {
    if (form.dataset.ilValidationBound === '1') return;
    form.dataset.ilValidationBound = '1';
    injectStyle();

    var fields = [];
    Array.prototype.forEach.call(form.querySelectorAll('input'), function (input) {
      var kind = kindOf(input);
      if (!kind) return;
      fields.push({ input: input, kind: kind });

      if (kind === 'id') {
        input.setAttribute('inputmode', 'numeric');
        input.setAttribute('maxlength', '9');
        input.addEventListener('input', function () {
          var only = digitsOnly(input.value).slice(0, 9);
          if (input.value !== only) input.value = only;
        });
      }
      if (kind === 'phone') input.setAttribute('inputmode', 'tel');

      input.addEventListener('blur', function () { validate(input, kind); });
      input.addEventListener('input', function () {
        if (input.getAttribute('aria-invalid') === 'true') validate(input, kind);
      });
    });

    if (!fields.length) return;

    form.addEventListener('submit', function (event) {
      var firstBad = null;
      fields.forEach(function (f) {
        if (!validate(f.input, f.kind) && !firstBad) firstBad = f.input;
      });
      if (firstBad) {
        event.preventDefault();
        firstBad.focus();
        if (typeof firstBad.reportValidity === 'function') firstBad.reportValidity();
      }
    });
  }

  function bindAll() {
    Array.prototype.forEach.call(document.querySelectorAll('.js-il-validate'), function (marker) {
      var form = marker.closest('form');
      if (form) attach(form);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindAll);
  else bindAll();
  document.addEventListener('shopify:section:load', bindAll);
})();
